<div class="learning-list">
  <div class="learning-list-heading">
      <header class="header-fixed" style="padding:0px 0px !important">
          <div class="header-limiter">
              <nav>
                  <a class="sub-menu-label" style="padding:17px 40px !important" href="javascript:void(0);">{{headerLabelText}}</a>
                  <a class="link hand-cursor"  style="padding:17px 40px !important" href="javascript:void(0);" (click)="ViewAll(learningCount,CardType)">{{viewAllLabel}} ({{learningCount}})</a>
                  <img class ="cardListLoader"/>

                </nav>
          </div>
      </header>
  </div>
  <ul class="learning-list-ul projectList" *ngIf="LearningList else NoLearning">
      <div class="owl-carousel owl-theme owl-carousel-projects">
          <app-learning-card [LearningCard]="card" [CardType]="CardType" *ngFor="let card of LearningList; let i = index" [attr.data-index]="i"></app-learning-card>
      </div>
  </ul>
</div>
<ng-template #NoLearning>
    <div class="no-item-display">
        <span>
            <i>{{bs.getResource('rbkey_NoItmToDsply')}}</i>
        </span>
    </div>
</ng-template>